import { render, staticRenderFns } from "./DisplayUsage.vue?vue&type=template&id=67c8f985"
import script from "./DisplayUsage.vue?vue&type=script&lang=js"
export * from "./DisplayUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports